import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, CardHeader as MuiCardHeader } from '@material-ui/core';
import clsx from 'clsx';

const propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'noPadding']),
};

const defaultProps = {
  variant: 'default',
};

const useStyles = makeStyles(theme => ({
  header: {
    backgroundColor: theme.palette.type === 'light' ? '#F4F4F4' : '#2D3436',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  noPadding: {
    padding: 0,
  },
  content: {
    width: '100%',
  },
}));

function CardHeader({ children, variant }) {
  const classes = useStyles();
  return (
    <MuiCardHeader
      classes={{
        root: clsx(classes.header, { [classes.noPadding]: variant === 'noPadding' }),
        content: classes.content,
      }}
      disableTypography
      title={children}
    >
      {children}
    </MuiCardHeader>
  );
}

CardHeader.propTypes = propTypes;
CardHeader.defaultProps = defaultProps;

export default CardHeader;
